import {
  ContractsIcon,
  ExecutorsIcon,
  IconInstruction,
  IconModerationRequest,
  IconNewspaper,
  IconOrders,
  IconProfile,
  NotificationIcon,
  WalletIcon,
} from 'assets/icons';
import { ProfilePermissions } from 'reduxStore/reducers/ProfileSlice/types';

interface NavLinkModel {
  link: string;
  name: string;
  icon: import('react').ReactNode;
  counter?: boolean;
  guardPermissions?: ProfilePermissions[];
}

export const navLinks: NavLinkModel[] = [
  { link: '/profile', name: 'Профиль', icon: <IconProfile /> },
  {
    link: '/moderation-request',
    name: 'Заявка на модерацию',
    icon: <IconModerationRequest />,
    guardPermissions: [
      ProfilePermissions.Request_Executor,
      ProfilePermissions.Request_ExecutorSubcontractor,
      ProfilePermissions.Agent_PaymentRequest_ReadExecutor,
      ProfilePermissions.ModerationRequest_Create,
      ProfilePermissions.VerificationQuestionary_Create,
    ],
  },
  {
    link: '/balance',
    name: 'Баланс',
    icon: <WalletIcon />,
    guardPermissions: [ProfilePermissions.Agent_Customers_Representative],
  },
  {
    link: '/orders',
    name: 'Заявки',
    icon: <IconOrders />,
    guardPermissions: [
      ProfilePermissions.Request_Executor,
      ProfilePermissions.Request_ExecutorSubcontractor,
    ],
  },
  {
    link: '/executors',
    name: 'Исполнители',
    icon: <ExecutorsIcon />,
    guardPermissions: [
      ProfilePermissions.Document_ReadExecutors,
      ProfilePermissions.Invitation_InvitationsCooperate_Read,
    ],
  },
  {
    link: '/agent/orders',
    name: 'Заявки',
    icon: <IconOrders />,
    guardPermissions: [ProfilePermissions.Agent_PaymentRequest_ReadExecutor],
  },
  {
    link: '/client/orders',
    name: 'Заявки',
    icon: <IconOrders />,
    guardPermissions: [
      ProfilePermissions.Agent_Bank_Manager,
      ProfilePermissions.Agent_Accreditaion_employee,
    ],
  },
  {
    link: '/client/customerrepresentative/orders',
    name: 'Заявки',
    icon: <IconOrders />,
    guardPermissions: [ProfilePermissions.Agent_Customers_Representative],
  },
  {
    link: '/receipts',
    name: 'Чеки',
    icon: <IconNewspaper />,
    guardPermissions: [ProfilePermissions.Billing_GetMyExecutorReceipts],
  },
  {
    link: '/agent/receipts',
    name: 'Чеки',
    icon: <IconNewspaper />,
    guardPermissions: [ProfilePermissions.Agent_PaymentRequest_ReadExecutor],
  },
  {
    link: '/help',
    name: 'Инструкция',
    icon: <IconInstruction />,
    guardPermissions: [
      ProfilePermissions.Request_Executor,
      ProfilePermissions.Request_ExecutorSubcontractor,
      ProfilePermissions.Agent_PaymentRequest_ReadExecutor,
      ProfilePermissions.VerificationQuestionary_Create,
      ProfilePermissions.ModerationRequest_Create,
    ],
  },
  {
    link: '/fts-notifications',
    name: 'Уведомления ФНС',
    icon: <NotificationIcon />,
    counter: true,
    guardPermissions: [ProfilePermissions.Agent_PaymentRequest_ReadExecutor],
  },
  {
    link: '/contracts',
    name: 'Документооборот',
    icon: <ContractsIcon />,
    guardPermissions: [ProfilePermissions.DocumentOrganization_User_Read],
  },
];

export const textMotionVariant = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
  },
};

export const SIDEBAR_OPEN_LOCALSTORAGE_NAME = 'sidebar-open';
